document.addEventListener("DOMContentLoaded", function () {
    let stickyCart = document.querySelector(".sticky-cart");
    let mainCartButton = document.querySelector(".payment-buttons");

    function toggleStickyCart() {
        if (!mainCartButton || !stickyCart) return;

        // Ensure sticky cart only works on mobile screens (≤ 768px)
        if (window.innerWidth > 768) {
            stickyCart.style.display = "none"; // Hide on desktop
            return;
        } else {
            stickyCart.style.display = "flex"; // Ensure it can appear on mobile
        }

        let mainCartButtonPosition = mainCartButton.getBoundingClientRect().bottom + window.scrollY;
        let scrollPosition = window.scrollY + window.innerHeight;

        if (scrollPosition > mainCartButtonPosition + 50) {
            stickyCart.classList.add("show-cart");
        } else {
            stickyCart.classList.remove("show-cart");
        }
    }

    window.addEventListener("scroll", toggleStickyCart);
    window.addEventListener("resize", toggleStickyCart);

    // Run function on load to hide the button on desktop initially
    toggleStickyCart();
});
